/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import jwt from 'jsonwebtoken';
import { Router } from '../../routes';

export const AuthContext = React.createContext();

// Auth HCO
export function withAuth(AuthComponent) {

  return class AuthWrapped extends Component {

    static getInitialProps(ctx) {
      if (AuthComponent.getInitialProps) {
        return AuthComponent.getInitialProps(ctx);
      }
    }

    render() {
      return (
        <AuthContext.Consumer>
          {context => <AuthComponent {...context} {...this.props} />}
        </AuthContext.Consumer>
      );
    }
  };
}

// Auth Provider
class Auth extends Component {

  static propTypes = {
    children: PropTypes.node,
  }

  static defaultProps = {
    children: undefined,
  }

  state = {
    isLoggedIn: false,
    privateRoute: false,
  }

  componentDidMount() {
    this.checkLoggedIn();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.route !== this.props.route) {
      this.checkLoggedIn();
    }
  }

  checkLoggedIn = () =>
    new Promise((resolve) => {
      if (this.loggedIn()) {
        const { userId } = this.getProfile().user;

        this.setState({
          isLoggedIn: userId,
        });

        return resolve(userId);
      }

      this.setState({
        isLoggedIn: false,
      });

      return resolve(false);
    });

  // Retrieves the user token from localStorage
  getToken = () => localStorage.getItem('w4w_token');

  // Decode jwt to retrieve user info
  getProfile = () => {
    const tok = jwt.decode(this.getToken());

    return tok;
  }

  isTokenValid = (token) => {
    try {
      const decoded = jwt.decode(token);

      // Checking if token is expired.
      if (decoded.exp < Date.now() / 1000) {
        return false;
      }

      return true;
    } catch (err) {
      return false;
    }
  }

  // Checks if there is a saved token and it's still valid
  loggedIn = () => {
    const token = this.getToken();

    return token != null && !!token && this.isTokenValid(token);
  }

  // Clear user token and profile data from localStorage
  logout = () => {
    this.setState({
      isLoggedIn: false,
    });

    localStorage.removeItem('w4w_token');

    if (this.state.privateRoute) {
      Router.push('/login');
    }
  }

  setPrivateRoute = (val) => {
    this.setState({
      privateRoute: val,
    }, () => {
      if (val && !this.state.isLoggedIn) {
        this.logout();
      }
    });
  }

  render() {
    return (
      <AuthContext.Provider
        value={{
          loggedIn: this.state.isLoggedIn,
          checkLoggedIn: this.loggedIn,
          logout: this.logout,
          isTokenValid: this.isTokenValid,
          privateRoute: this.state.privateRoute,
          setPrivateRoute: this.setPrivateRoute,
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export default Auth;
